import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import ReactPhoneInput from "react-phone-input-2";

// GraphQL
import UpdateUserMutation from "../../GraphQL/Mutations/UpdateUser";
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentation/UI
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  userId: any;
  user: any;
  closeModal(): void;
  notification(message: string): void;
}

interface IState {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  loading: boolean;
  error: null | string;
}

class EditUserForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      id: props.user.id,
      firstName: !props.user.firstName ? "" : props.user.firstName,
      lastName: !props.user.lastName ? "" : props.user.lastName,
      phoneNumber: !props.user.phoneNumber ? "" : props.user.phoneNumber,
      loading: false,
      error: null
    };
  }

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "firstName":
        this.setState({ firstName: value });
        break;
      case "lastName":
        this.setState({ lastName: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    const { firstName, lastName, phoneNumber } = this.state;
    // Check for undefined or empty infput fields
    if (!firstName || !lastName || !phoneNumber) {
      this.setError("Please fill in the fields");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const { id, firstName, lastName, phoneNumber } = this.state;
    const { userId, closeModal, notification } = this.props;
    return (
      <Mutation<{}, {}> mutation={UpdateUserMutation}>
        {(updateUser, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              if (this.validateForm()) {
                this.setState({ loading: true });

                updateUser({
                  variables: {
                    id,
                    firstName,
                    lastName,
                    phoneNumber
                  },
                  refetchQueries: [
                    {
                      query: GetUserDetails,
                      variables: { id: userId }
                    }
                  ]
                })
                  .then(res => {
                    this.setState({ loading: false });

                    closeModal();
                    notification("Profile updated successfully");
                  })
                  .catch(err => {
                    this.setState({ loading: false });
                  });
              }
            }}
          >
            <FormGroup>
              <Label for="firstName">First Name</Label>
              <Input
                type="text"
                name="firstName"
                value={firstName}
                id="firstName"
                placeholder="First name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="lastName">Last Name</Label>
              <Input
                type="text"
                name="lastName"
                value={lastName}
                id="lastName"
                placeholder="Last name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Phone Number</Label>
              <ReactPhoneInput
                value={phoneNumber}
                defaultCountry={"za"}
                onChange={(userPhoneNumber: any) =>
                  this.setState({ phoneNumber: userPhoneNumber })
                }
              />
            </FormGroup>
            <br />
            <FormGroup>
              <Button>
                {!this.state.loading ? <span>Update</span> : <Loader />}
              </Button>
            </FormGroup>
            {this.state.error && (
              <p style={{ textAlign: "center", color: Colors.error }}>
                {this.state.error}
              </p>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default EditUserForm;



// WEBPACK FOOTER //
// ./src/Components/Header/EditProfileForm.tsx